import { contact } from "../../models/site";
import { SmartImage } from "../SmartImage";

export function RentalPage() {
  return (
    <div className="standard-page rental-page">
      <section className="rental-hero">
        <SmartImage name="patio" alt="適合包棟聚會的都蘭小星公共空間" eager />
        <div>
          <p className="eyebrow">A PLACE OF YOUR OWN</p>
          <h1>
            包棟<span>FULL PROPERTY RENTAL</span>
          </h1>
        </div>
      </section>
      <div className="rental-content">
        <section>
          <h2>
            一棟小屋，
            <br />
            一群人，一段都蘭時光。
            <span>A house of your own, for good times together in Dulan.</span>
          </h2>
          <p>
            小星包棟最多可入住 16
            人，四人一房，皆為舒適的眠豆腐單人床。適合家人、朋友、工作坊與小型聚會。
          </p>
          <p>
            A full-property stay welcomes up to 16 guests, with four people per
            room and a comfortable single mattress for everyone. It is a relaxed
            setting for families, friends, workshops and small gatherings.
          </p>
        </section>
        <section className="price-card">
          <p>平日 WEEKDAY · SUN–THU</p>
          <strong>NT$13,000</strong>
          <span>每晚 · per night</span>
          <p>週末與假日 WEEKEND · FRI, SAT & HOLIDAYS</p>
          <strong>NT$14,000</strong>
          <span>每晚 · per night</span>
          <small>
            最少入住兩晚。三晚 9 折，七晚 85 折。
            <br />
            Minimum stay: two nights. Stay three nights for 10% off, or seven
            nights for 15% off.
          </small>
          <a
            href={`mailto:${contact.email}?subject=${encodeURIComponent("都蘭小星包棟詢問")}`}
            className="outline-dark"
          >
            聯絡我們 CONTACT US
          </a>
        </section>
      </div>
    </div>
  );
}
